/* eslint-disable @typescript-eslint/no-unused-expressions */
import React, { useContext, useEffect } from "react";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
  useParams,
} from "react-router-dom";
import { MainContextProvider, MainContext } from "./context/main";
import Home from "./screens/home/Home";
import Quizz from "./screens/quizz/Quizz";
import QuizzNew from "./screens/quizz-new/QuizzNew";

import Gallery from "./screens/gallery/Gallery";
import Leads from "./screens/leads/Leads";
import LeadsNew from "./screens/leads-new/LeadsNew";

import Cart from "./screens/cart/Cart";
import "@cocunat/ui-components/dist/index.css";
import * as ReactDOMClient from "react-dom/client";
import { getCountryRegion } from "./common/regions";
import { urlToLocale } from "./helpers";

const enviroment = process.env.REACT_APP_STRIPE_API || "live";
declare const window: any;

function Error404() {
  return <p>Error404</p>;
}

const RouteMiddleware = () => {
  const location = useLocation();
  const { region, setRegion } = useContext(MainContext);

  const fetchRegion = async (country: string) => {
    try {
      let response = await getCountryRegion(country);
      if (response.status === 200) {
        setRegion(response.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const [lang, country] = urlToLocale(location.pathname);

    if (!region) {
      fetchRegion(country);
    }
  }, [location]);

  useEffect(() => {});
  return <></>;
};

function AppRouter() {
  useEffect(() => {
    const noop = () => {};

    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l !== "dataLayer" ? "&l=" + l : "";
      j.setAttribute("defer", "true");
      j.setAttribute(
        "src",
        "https://www.googletagmanager.com/gtm.js?id=" + i + dl
      );
      f.parentNode.insertBefore(j, f);
    })(window, document, "script", "dataLayer", "GTM-KW3SVVL");

    function amm() {
      try {
        var s, d;
        s = localStorage.getItem("amm");
        d = JSON.parse(s);
        if (d) {
          return d;
        }
      } catch (err) {
        console.log(err);
      }
    }

    (function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      "script",
      "https://connect.facebook.net/en_US/fbevents.js"
    );
    let fbq = window.fbq || noop;
    fbq("init", "1983837231849232", amm());
    fbq("track", "PageView");

    (function (i, s, o, g, r, a, m) {
      i["GoogleAnalyticsObject"] = r;
      (i[r] =
        i[r] ||
        function () {
          (i[r].q = i[r].q || []).push(arguments);
        }),
        (i[r].l = new Date());
      (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
      a.async = 1;
      a.src = g;
      m.parentNode.insertBefore(a, m);
    })(
      window,
      document,
      "script",
      "https://www.google-analytics.com/analytics.js",
      "ga"
    );
    let ga = window.ga || noop;
    ga("create", "UA-42631937-5", "auto");
    ga("require", "GTM-NJNWVNZ");
    ga("require", "ec");
    document.addEventListener("DOMContentLoaded", function () {
      ga("send", "pageview");
    });

    (function (e) {
      if (!window.pintrk) {
        window.pintrk = function () {
          window.pintrk.queue.push(Array.prototype.slice.call(arguments));
        };
        var n = window.pintrk;
        (n.queue = []), (n.version = "3.0");
        var t = document.createElement("script");
        (t.defer = true), (t.src = e);
        var r = document.getElementsByTagName("script")[0];
        r.parentNode.insertBefore(t, r);
      }
    })("https://s.pinimg.com/ct/core.js");
    let pintrk = window.pintrk || noop;
    pintrk("load", "2613118972119");
    pintrk("page");
    pintrk("track", "pagevisit");

    (function (w, d, t) {
      w.TiktokAnalyticsObject = t;
      var ttq = (w[t] = w[t] || []);
      (ttq.methods = [
        "page",
        "track",
        "identify",
        "instances",
        "debug",
        "on",
        "off",
        "once",
        "ready",
        "alias",
        "group",
        "enableCookie",
        "disableCookie",
      ]),
        (ttq.setAndDefer = function (t, e) {
          t[e] = function () {
            t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
          };
        });
      for (var i = 0; i < ttq.methods.length; i++)
        ttq.setAndDefer(ttq, ttq.methods[i]);
      (ttq.instance = function (t) {
        for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++)
          ttq.setAndDefer(e, ttq.methods[n]);
        return e;
      }),
        (ttq.load = function (e, n) {
          var i = "https://analytics.tiktok.com/i18n/pixel/events.js";
          (ttq._i = ttq._i || {}),
            (ttq._i[e] = []),
            (ttq._i[e]._u = i),
            (ttq._t = ttq._t || {}),
            (ttq._t[e] = +new Date()),
            (ttq._o = ttq._o || {}),
            (ttq._o[e] = n || {});
          n = document.createElement("script");
          (n.type = "text/javascript"),
            (n.defer = !0),
            (n.src = i + "?sdkid=" + e + "&lib=" + t);
          e = document.getElementsByTagName("script")[0];
          e.parentNode.insertBefore(n, e);
        });

      ttq.load("C8770CGJVRJHAP8GSAH0");
      ttq.page();
    })(window, document, "ttq");

    (function () {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "https://182114.tracking.hyros.com/v1/lst/universal-script?ph=55518a23778d3981fb75ba8a5956c64dbd125a52aab869d88e7c13cd0fc0c75e&tag=!tracking";
      script.defer = true;
      document.getElementsByTagName("body")[0].appendChild(script);
    })();

    (function () {
      window._rsq = window._rsq || [];
      var rScix = document.createElement("script");
      rScix.type = "text/javascript";
      rScix.defer = true;
      rScix.src =
        ("https:" === document.location.protocol ? "https://" : "http://") +
        "d1stxfv94hrhia.cloudfront.net/waves/v3/w.js";
      document.getElementsByTagName("body")[0].appendChild(rScix);
    })();
  }, []);
  return (
    <MainContextProvider>
      <BrowserRouter>
        <RouteMiddleware />
        <Routes>
          <Route path="/:lang-:country/" element={<Home />} />
          <Route path="/:lang-:country/quizz/:step/" element={<Quizz />} />
          <Route
            path="/:lang-:country/quizz-new/:step/"
            element={<QuizzNew />}
          />

          <Route path="/:lang-:country/gallery/" element={<Gallery />} />
          <Route path="/:lang-:country/leads/" element={<Leads />} />
          <Route path="/:lang-:country/leads-new/" element={<LeadsNew />} />

          <Route path="/:lang-:country/cart/" element={<Cart />} />
          <Route path="/" element={<Error404 />} />
        </Routes>
      </BrowserRouter>
    </MainContextProvider>
  );
}

const container = document.getElementById("root") as HTMLElement;

// Create a root.
const root = ReactDOMClient.createRoot(container);

// Initial render: Render an element to the root.
root.render(<AppRouter />);
